// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLoader_container__1p3BP","loader":"PageLoader_loader__1YMSH","spin":"PageLoader_spin__3o8uk"};